import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/lukas/Sites/git/own-packages/react-i18n-kit/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from "docz";
import { Translator } from "./components";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Translator heading page="functions" num="0" mdxType="Translator" />
    <Translator page="functions" num="0" mdxType="Translator" />
    <Translator heading page="functions" num="1" mdxType="Translator" />
    <Translator page="functions" num="1" mdxType="Translator" />
    <Translator heading page="functions" num="3" mdxType="Translator" />
    <Translator page="functions" num="2" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const { i18n, translate } = useI18n(data, options);
`}</code></pre>
    <Translator page="functions" num="8" mdxType="Translator" />
    <Translator heading page="functions" num="4" mdxType="Translator" />
    <Translator page="functions" num="6" mdxType="Translator" />
    <Translator heading page="functions" num="6" mdxType="Translator" />
    <Translator page="functions" num="9" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const data = {
  de: {
    text: "Hallo Welt!",
  },
  en: {
    text: "Hello World!",
  },
};
`}</code></pre>
    <Translator heading page="functions" num="7" mdxType="Translator" />
    <Translator page="functions" num="10" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const options = {
  lang: "de",
  fallback: "de",
};
`}</code></pre>
    <Translator heading page="functions" num="2" mdxType="Translator" />
    <Translator page="functions" num="3" mdxType="Translator" />
    <Translator heading page="functions" num="3" mdxType="Translator" />
    <Translator page="functions" num="4" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const i18n = withI18n(Component, data, options);
`}</code></pre>
    <Translator heading page="functions" num="4" mdxType="Translator" />
    <Translator page="functions" num="5" mdxType="Translator" />
    <Translator heading page="functions" num="5" mdxType="Translator" />
    <Translator page="functions" num="7" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const Text = (props) => (
  <div>
    <button onClick={() => props.translate('en')}>
      English
    <button/>
    <button onClick={() => props.translate('de')}>
      Deutsch
    <button/>
    {props.i18n.text}
  </div>
);
`}</code></pre>
    <Translator page="functions" num="8" mdxType="Translator" />
    <Translator heading page="functions" num="6" mdxType="Translator" />
    <Translator page="functions" num="9" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const data = {
  de: {
    text: "Hallo Welt!",
  },
  en: {
    text: "Hello World!",
  },
};
`}</code></pre>
    <Translator heading page="functions" num="7" mdxType="Translator" />
    <Translator page="functions" num="10" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const options = {
  lang: "de",
  fallback: "de",
};
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      